export const checkboxCategories = ["vision", "sunglasses", "sports"];

export const gendersList = ["all", "men", "women", "unisex"];

export const ratings = [1, 2, 3, 4];
